import { render, staticRenderFns } from "./cabinet-user-change-certificate.vue?vue&type=template&id=3fa71c52&"
import script from "./cabinet-user-change-certificate.vue?vue&type=script&lang=js&"
export * from "./cabinet-user-change-certificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa71c52')) {
      api.createRecord('3fa71c52', component.options)
    } else {
      api.reload('3fa71c52', component.options)
    }
    module.hot.accept("./cabinet-user-change-certificate.vue?vue&type=template&id=3fa71c52&", function () {
      api.rerender('3fa71c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/organization/cabinet-user-change-certificate.vue"
export default component.exports